import axios from 'axios';
import { BASE_API_URL } from "../utils/api-url";

export async function getCities(accessToken, state_id) {
  const result = await axios.get(`${BASE_API_URL}/cities/${state_id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function createUser(accessToken, data) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/city`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}


